<template>
  <b-container fluid class="py-4">
    <b-card no-body class="mb-4 shadow-sm rounded-lg">
      <b-card-header class="bg-white border-0 py-3">
        <h3 class="mb-0 font-weight-bold text-dark">Kemaskini Pengguna</h3>
      </b-card-header>
      <b-card-body class="p-4">
        <b-form @submit.prevent="updateProfile">
          <b-row>
            <b-col lg="6" class="mb-4">
              <b-form-group label="Nama" label-class="font-weight-bold text-muted">
                <p class="form-control-static text-dark">{{ user.name }}</p>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="mb-4">
              <b-form-group label="No Kad Pengenalan" label-class="font-weight-bold text-muted">
                <p class="form-control-static text-dark">{{ user.icno }}</p>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="mb-4">
              <b-form-group label="Emel" label-class="font-weight-bold text-muted">
                <p class="form-control-static text-dark">{{ user.email }}</p>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="mb-4">
              <b-form-group label="Peranan" label-class="font-weight-bold text-muted">
                <b-form-select id="user-role" v-model="user.status_entitle" :options="roleOptions"
                  class="custom-select rounded-pill"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col lg="6" class="mb-4">
              <b-form-group label="Status Pengguna" label-class="font-weight-bold text-muted">
                <b-form-select id="user-active" v-model="user.active_status" :options="activeOptions"
                  class="custom-select rounded-pill"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <div class="d-flex justify-content-end mt-4">
            <b-button variant="primary" type="submit" class="rounded-pill px-4 py-2 mr-2"
              :disabled="isSubmitting || isOwnProfile">
              <i class="fas fa-save mr-1"></i>
              {{ isSubmitting ? 'Memproses...' : 'Kemaskini' }}
            </b-button>
            <b-button variant="outline-secondary" class="rounded-pill px-4 py-2" @click="navigateBack"
              :disabled="isSubmitting">
              <i class="fas fa-arrow-left mr-1"></i> Kembali
            </b-button>
          </div>
        </b-form>
      </b-card-body>
    </b-card>
  </b-container>
</template>
<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { baseURL } from '../../../services/baseURL';
export default {
  name: 'UserEdit',
  data() {
    return {
      user: {},
      currentUser: null,
      isSubmitting: false,
      defaultRoleOptions: [
        { value: null, text: 'Sila Pilih Peranan' },
        { value: 'admin', text: 'Sekretariat' },
        { value: 'pentadbir', text: 'Pentadbir Organisasi' },
        { value: 'pentadbir awam', text: 'Pentadbir Organisasi' },
        {
          value: 'pengguna',
          text: this.currentUser && this.currentUser.peranan === 'pentadbir awam' ? 'Pengguna' : 'Pentadbir Agensi'
        },
      ],
      activeOptions: [
        { value: null, text: 'Sila Pilih Status' },
        { value: 'aktif', text: 'Aktif' },
        { value: 'tidak_aktif', text: 'Tidak Aktif' },
      ],
    };
  },
  computed: {
    login_obj() {
      return {
        id: this.user.id,
        name: this.user.name,
        email: this.user.email,
        role: this.user.status_entitle,
        active_status: this.user.active_status,
      };
    },
    roleOptions() {
    // Jika user_type adalah 'public', hanya tampilkan Pentadbir Awam dan Pengguna
    if (this.user.user_type === 'public') {
      return [
        { value: null, text: 'Sila Pilih Peranan' },
        { value: 'pentadbir awam', text: 'Pentadbir Organisasi' },
        { value: 'pengguna', text: 'Pengguna' },
      ];
    }


    // Logika sebelumnya berdasarkan currentUser
    if (this.currentUser && this.currentUser.peranan === 'pentadbir awam') {
      return [
        { value: null, text: 'Sila Pilih Peranan' },
        { value: 'pentadbir awam', text: 'Pentadbir Organisasi' },
        { value: 'pengguna', text: 'Pengguna' },
      ];
    } else if (this.currentUser && (this.currentUser.peranan === 'admin' || this.currentUser.peranan === 'pentadbir')) {
      return [
        { value: null, text: 'Sila Pilih Peranan' },
        { value: 'admin', text: 'Sekretariat' },
        { value: 'pentadbir', text: 'Pentadbir Organisasi' },
        { value: 'pengguna', text: 'Pentadbir Agensi' },
      ];
    }
    return this.defaultRoleOptions;
  },
  isOwnProfile() {
    // Jika user_id (dari data profil) sama dengan id currentUser → disable kemaskini
    return (
      this.currentUser &&
      (this.user.user_id === this.currentUser.id ||
        this.user.id === this.currentUser.id)
    );
  },
  },
  methods: {
    async updateProfile() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;
      try {
        const response = await axios.post(`${baseURL}/update_peranan.php`, this.login_obj, {
          headers: { 'Content-Type': 'application/json' },
        });
        if (response.data.status === 'success') {
          Swal.fire({
            icon: 'success',
            title: 'Berjaya!',
            text: 'Kemaskini pengguna berjaya.',
            confirmButtonText: 'OK',
          }).then(() => {
            this.$router.push('/user');
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Gagal',
            text: `Kemaskini gagal: ${response.data.message || 'Tidak diketahui'}`,
            confirmButtonText: 'OK',
          });
        }
      } catch (error) {
        // console.error('Update error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Ralat',
          text: 'Terjadi ralat semasa kemaskini.',
          confirmButtonText: 'OK',
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    async getProfile() {
      try {
        const response = await axios.post(
          `${baseURL}/papar_profile_edit.php`,
          { user: { id: this.$route.params.id } },
          { headers: { 'Content-Type': 'application/json' } }
        );
        this.user = response.data[0];
      } catch (error) {
        // console.error('Error fetching profile:', error);
        Swal.fire({
          icon: 'error',
          title: 'Ralat',
          text: 'Gagal memuatkan data pengguna.',
          confirmButtonText: 'OK',
        });
      }
    },
    navigateBack() {
      this.$router.push('/user');
    },
    loadCurrentUser() {
      const userData = localStorage.getItem('user');
      if (userData) {
        try {
          this.currentUser = JSON.parse(userData);
          // Update defaultRoleOptions after currentUser is loaded
          this.defaultRoleOptions = [
            { value: null, text: 'Sila Pilih Peranan' },
            { value: 'admin', text: 'Sekretariat' },
            { value: 'pentadbir', text: '' },
            { value: 'pentadbir awam', text: 'Pentadbir Organisasi' },
            {
              value: 'pengguna',
              text: this.currentUser && this.currentUser.peranan === 'pentadbir awam' ? 'Pengguna' : 'Pentadbir Agensi'
            },
          ];
        } catch (error) {
          // console.error('Error parsing localStorage user data:', error);
        }
      }
    },
  },
  created() {
    this.loadCurrentUser();
    this.getProfile();
  },
};
</script>
<style scoped>
.card {
  background: #fff;
  border: 1px solid #e9ecef;
}
.card-header {
  background: #f8f9fa;
  color: #343a40;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: 2px solid #dee2e6;
  padding: 1rem;
}
.form-control-static {
  font-size: 0.875rem;
  color: #343a40;
  margin-bottom: 0;
}
.custom-select {
  border: 1px solid #ced4da;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  transition: border-color 0.2s ease;
}
.custom-select:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.1);
}
.text-dark {
  color: #343a40 !important;
}
.text-muted {
  color: #6c757d !important;
}
.btn-primary,
.btn-outline-secondary {
  font-size: 0.875rem;
  padding: 0.5rem 1.5rem;
}
.rounded-pill {
  border-radius: 50rem !important;
}
h3 {
  font-size: 1.5rem;
}
label {
  font-size: 0.875rem;
}
</style>
